import { render, staticRenderFns } from "./PantallaSurtirConFolio.vue?vue&type=template&id=df4ea10a&"
import script from "./PantallaSurtirConFolio.vue?vue&type=script&lang=js&"
export * from "./PantallaSurtirConFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports